import type { User } from '@/interfaces/user.interface'
import { HttpMethod, Performer } from './core'

export class GetUser extends Performer<void, User> {
  protected method = HttpMethod.GET
  protected url = '/user'
}
